import { render, staticRenderFns } from "./violationProportion.vue?vue&type=template&id=68d43a6e&scoped=true&"
import script from "./violationProportion.vue?vue&type=script&lang=js&"
export * from "./violationProportion.vue?vue&type=script&lang=js&"
import style0 from "./violationProportion.vue?vue&type=style&index=0&id=68d43a6e&prod&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "68d43a6e",
  null
  
)

export default component.exports